
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/faq",
      function () {
        return require("private-next-pages/home/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/faq"])
      });
    }
  